//cart actions
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE';
export const UPDATE_SINGLE_PRODUCT = 'UPDATE_SINGLE_PRODUCT';
export const REMOVE_PACKAGE_ITEM = 'REMOVE_PACKAGE_ITEM';
export const UPDATE_CART_EMAIL = 'UPDATE_CART_EMAIL';
export const EMPTY_CART = 'EMPTY_CART';
export const REFRESH_CART = 'REFRESH_CART';
export const FETCH_CART_GIFTS = 'FETCH_CART_GIFTS';

//cart helper actions
export const DISABLE_SUBMITED = 'DISABLE_SUBMITED';
export const ADD_DISCOUNT = 'ADD_DISCOUNT';
export const FETCH_MESSAGE_DESIGNS = 'FETCH_MESSAGE_DESIGNS';
export const SET_MESSAGE_PICKER = 'SET_MESSAGE_PICKER';

//cfg actions
export const CHANGE_PRODUCT = 'CHANGE_PRODUCT';
export const LOAD_ITEMS_TO_CFG = 'LOAD_ITEMS_TO_CFG';
export const EMPTY_CFG = 'EMPTY_CFG';

//checkout actions
export const UPDATE_CHECKOUT_FIELD = 'UPDATE_CHECKOUT_FIELD';
export const UPDATE_DELIVERY_FIELD = 'UPDATE_DELIVERY_FIELD';
export const UPDATE_ZASILKOVNA = 'UPDATE_ZASILKOVNA';
export const UPDATE_ERRORS = 'UPDATE_ERRORS';
export const SET_DELIVERY_DATE = 'SET_DELIVERY_DATE';

//filter actions
export const SET_FILTER = 'SET_FILTER';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY';
export const SET_ORDER_TYPE = 'SET_ORDER_TYPE';
export const RESET_FILTER = 'RESET_FILTER';

//inspiration actions
export const FETCH_INSPIRATION = 'FETCH_INSPIRATION';
export const GET_INSPIRATION = 'GET_INSPIRATION';
export const EMPTY_INSPIRATION = 'EMPTY_INSPIRATION';

//packages actions
export const FETCH_PACKAGES = 'FETCH_PACKAGES';

//page settings actions
export const SWITCH_CURRENCY = 'SWITCH_CURRENCY';
export const FETCH_EUR_EXCHANGE_RATE = 'FETCH_EUR_EXCHANGE_RATE';
export const SET_COUNTRY_SETTINGS = 'SET_COUNTRY_SETTINGS';
export const SET_PREVIOUS_LOCATION = 'SET_PREVIOUS_LOCATION';

//product actions
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const SEARCH = 'SEARCH';
export const SET_PRODUCT = 'SET_PRODUCT';

//store design actions
export const FETCH_HOMEPAGE = 'FETCH_HOMEPAGE';
